var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eqs-badge",style:({ ..._vm.getStyle, ..._vm.additionalStyle }),attrs:{"el-class":_vm.elClass}},[_c('v-badge',_vm._g(_vm._b({},'v-badge',{ ..._vm.$attrs, ..._vm.getData },false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }